(function () {
    'use strict';

    if (typeof window === 'undefined') {
        utils(
            module.exports,
            require('../../enums/metrics.js'),
            require('lodash')
        );

    } else {
        utils(
            RivalIQ.module('utils.data'),
            RivalIQ.enums,
            window._
        );
    }

    function utils(exports, enums, _) {

        /*
         * This function transforms period values into an array of differences
         * between values given a timeAnalysisMode
         */
        exports.rollupDeltaValues = function (values, timeAnalysisMode) {
            const result = [null];

            for (let i = 1; i < values.length; i++) {
                if (_.isNull(values[i]) || _.isNull(values[i - 1])) {
                    result.push(null);
                    continue;
                }

                let value = values[i] - values[i - 1];
                if (timeAnalysisMode === enums.timeAnalysisMode.DELTA_RELATIVE) {
                    if (values[i - 1] === 0) {
                        // If the previous value was 0 this is an infinite
                        // percent change. Omit the point instead
                        value = null;
                    } else if (value !== 0) {
                        value = value / values[i - 1];
                    }
                }

                result.push(value);
            }

            return result;
        };

        /*
         * Splits data array into an array of data segments, splitting at nulls
         */
        exports.groupDataSegments = function (data, evalFn) {
            evalFn = evalFn || _.identity;
            const result = [];
            let startIndex = 0;

            let inSegment = !_.isNull(evalFn(data[0]));
            for (let i = 1; i < data.length; i++) {
                if (_.isNull(evalFn(data[i]))) {
                    if (inSegment) {
                        result.push(data.slice(startIndex, i));
                        inSegment = false;
                    }
                } else if (!inSegment) {
                    inSegment = true;
                    startIndex = i;
                }
            }

            if (inSegment) {
                result.push(data.slice(startIndex, data.length));
            }

            return result;
        };

        // '/ Post' or '/ Story' metrics
        exports.customMetricDivision = {
            engagement_total_per_post_insights: {
                numerator: 'engagement_total_insights',
                denominator: 'count'
            },
            organic_engagement_total_per_post: {
                numerator: 'organic_engagement_total',
                denominator: 'count'
            },
            paid_engagement_total_per_post: {
                numerator: 'paid_engagement_total',
                denominator: 'paid_daily_posts',
                ignoreNullValues: true
            },

            engagement_total_per_post: {
                numerator: 'engagement_total',
                denominator: 'count'
            },

            // DEPRECATED
            organic_engagement_rate_per_post: {
                numerator: 'organic_engagement_total',
                denominator: 'total_post_reach'
            },
            paid_engagement_rate_per_post: {
                numerator: 'paid_engagement_total',
                denominator: 'paid_reach_total',
                ignoreNullValues: true
            },
            // END DEPRECATED

            organic_engagement_rate_by_reach: {
                numerator: 'organic_engagement_total',
                denominator: 'total_post_reach'
            },
            paid_engagement_rate_by_reach: {
                numerator: 'paid_engagement_total',
                denominator: 'paid_reach_total',
                ignoreNullValues: true
            },

            engagement_rate_by_impression: {
                numerator: 'engagement_total_insights',
                denominator: 'post_impressions'
            },
            organic_engagement_rate_by_impression: {
                numerator: 'organic_engagement_total',
                denominator: 'organic_post_impressions'
            },
            paid_engagement_rate_by_impression: {
                numerator: 'paid_engagement_total',
                denominator: 'paid_post_impressions',
                ignoreNullValues: true
            },
            avg_engagement_rate_per_post: {
                numerator: 'engagement_total',
                denominator: 'total_post_reach'
            },

            // This logic is necessary because facebook and linkedin both have page_engagement_rate metrics that are defined differently.
            page_engagement_rate: (mappings) => {
                const channel = _.get(mappings, [0, 'channel']);
                if (channel === 'linkedin') {
                    return {
                        numerator: 'page_engagement_total',
                        denominator: 'page_update_impressions'
                    };
                } else {
                    return {
                        numerator: 'consumptions',
                        denominator: 'impressions'
                    };
                }
            },

            likes_per_post: {
                numerator: 'likes',
                denominator: 'count'
            },
            organic_likes_per_post: {
                numerator: 'organic_likes',
                denominator: 'count'
            },
            paid_likes_per_post: {
                numerator: 'paid_likes',
                denominator: 'paid_daily_posts',
                ignoreNullValues: true
            },

            comments_per_post: {
                numerator: 'comments',
                denominator: 'count'
            },
            organic_comments_per_post: {
                numerator: 'organic_comments',
                denominator: 'count'
            },
            paid_comments_per_post: {
                numerator: 'paid_comments',
                denominator: 'paid_daily_posts',
                ignoreNullValues: true
            },

            saves_per_post: {
                numerator: 'saves',
                denominator: 'count'
            },
            organic_saves_per_post: {
                numerator: 'organic_saves',
                denominator: 'count'
            },
            paid_saves_per_post: {
                numerator: 'paid_saves',
                denominator: 'paid_daily_posts',
                ignoreNullValues: true
            },

            shares_per_post: {
                numerator: 'shares',
                denominator: 'count'
            },
            organic_shares_per_post: {
                numerator: 'organic_shares',
                denominator: 'count'
            },
            paid_shares_per_post: {
                numerator: 'paid_shares',
                denominator: 'paid_daily_posts',
                ignoreNullValues: true
            },

            views_per_post: {
                numerator: 'views',
                denominator: 'count'
            },
            video_views_per_post: {
                numerator: 'video_views',
                denominator: 'num_videos'
            },
            organic_video_views_per_post: {
                numerator: 'organic_video_views',
                denominator: 'num_videos'
            },
            paid_video_views_per_post: {
                numerator: 'paid_video_views',
                denominator: 'paid_num_videos',
                ignoreNullValues: true
            },
            video_views_per_tweet: {
                numerator: 'video_views',
                denominator: 'video_tweets'
            },

            video_view_rate: {
                numerator: 'video_views',
                denominator: 'video_impressions'
            },
            organic_video_view_rate: {
                numerator: 'organic_video_views',
                denominator: 'organic_video_impressions'
            },
            paid_video_view_rate: {
                numerator: 'paid_video_views',
                denominator: 'paid_video_impressions'
            },

            engagement_total_per_view: {
                numerator: 'engagement_total',
                denominator: 'views'
            },

            impressions_per_post: {
                numerator: 'post_impressions',
                denominator: 'count'
            },
            organic_impressions_per_post: {
                numerator: 'organic_post_impressions',
                denominator: 'count'
            },
            paid_impressions_per_post: {
                numerator: 'paid_post_impressions',
                denominator: 'paid_daily_posts',
                ignoreNullValues: true
            },

            reach_per_post: {
                numerator: 'total_post_reach',
                denominator: 'count'
            },
            organic_reach_per_post: {
                numerator: 'organic_reach_total',
                denominator: 'count'
            },
            paid_reach_per_post: {
                numerator: 'paid_reach_total',
                denominator: 'paid_daily_posts',
                ignoreNullValues: true
            },

            // stories
            impressions_per_story: {
                numerator: 'story_impressions',
                denominator: 'num_stories'
            },
            stories_per_day: {
                numerator: 'num_stories',
                denominator: 'days_with_story'
            },
            story_max_reach_rate: {
                numerator: 'story_max_reach_rate',
                denominator: 'days_with_story'
            },
            story_max_reach_per_day: {
                numerator: 'story_max_reach_per_day',
                denominator: 'days_with_story'
            },
            reach_per_story: {
                numerator: 'story_reach',
                denominator: 'num_stories'
            },
            story_impressions_per_day: {
                numerator: 'story_impressions',
                denominator: 'days_with_story'
            },
            stories_retention_rate: {
                numerator: 'last_reach',
                denominator: 'first_reach'
            },
            completions_per_story: {
                numerator: 'completions',
                denominator: 'num_stories'
            },
            exit_rate_per_story: {
                numerator: 'exits',
                denominator: 'story_impressions'
            },
            exits_per_story: {
                numerator: 'exits',
                denominator: 'num_stories'
            },
            taps_back_per_story: {
                numerator: 'taps_back',
                denominator: 'num_stories'
            },
            average_taps_back_rate: {
                numerator: 'taps_back',
                denominator: 'story_impressions'
            },
            taps_forward_per_story: {
                numerator: 'taps_forward',
                denominator: 'num_stories'
            },
            average_taps_forward_rate: {
                numerator: 'taps_forward',
                denominator: 'story_impressions'
            },
            swipes_forward_per_story: {
                numerator: 'swipes_forward',
                denominator: 'num_stories'
            },
            shares_per_story: {
                numerator: 'story_shares',
                denominator: 'num_stories'
            }
        };

        // custom metrics (typically '/ day' metrics)
        exports.fn = {
            avg_engagement_total_per_day: engagementTotalPerDay,
            reach_rate_per_post: calculateReachRatePerPost('reach_rate_per_post', 'total_post_reach', 'count', false),
            organic_reach_rate_per_post: calculateReachRatePerPost('organic_reach_rate_per_post', 'organic_reach_total', 'organic_daily_posts', false),
            paid_reach_rate_per_post: calculateReachRatePerPost('paid_reach_rate_per_post', 'paid_reach_total', 'paid_daily_posts', true),
            average_full_view_rate: avgFullViewRate,
            average_reach_rate: averageReachRate,
            title_size: count('title'),
            overview_size: count('overview'),
            keywords_size: count('keywords'),
            about_size: count('about'),
            display_name_size: count('display_name'),
            overview_size_rating: metaDescriptionRating('overview'),

            avg_count_per_week: postsPerWeek('avg_count_per_week'),
            all_tweets_per_week: postsPerWeek('all_tweets_per_week'),
            replies_per_week: postsPerWeek('replies_per_week'),
            retweets_per_week: postsPerWeek('retweets_per_week'),
            normal_tweets_per_week: postsPerWeek('normal_tweets_per_week')
        };

        exports.compileFn = {
            sum: sum,
            mean: mean,
            last: last,
            lastValue: lastValue
        };

        exports.transformFn = {
            count: count,
            metaDescriptionRating: metaDescriptionRating
        };

        /*
         * Sum the array values
         * Returns null if any value in the array is null
         */
        function strictSum(array) {
            let value = 0;
            for (let i = 0; i < array.length; i++) {
                // partial periods will be set to null since not enough data to calculate period
                if (array[i] === null) {
                    return null;
                }
                value += array[i];
            }
            return value;
        }

        /*
         * Sum the array values
         * Ignores null values. Used for instagram insights paid data
         */
        function nonstrictSum(array) {
            const nonNullArray = _.dropWhile(array, _.isNull);
            if (_.size(nonNullArray) === 0) {
                return null;
            }

            return _.sum(nonNullArray);
        }

        /*
         * Divide the arguments
         * Returns null if either of the args are null
         * Returns 0 over NaN if the denominator is 0
         */
        function strictDivide(numerator, denominator) {
            if (_.isNull(numerator) || _.isNull(denominator)) {
                return null;
            }

            if (denominator === 0) {
                return 0;
            }

            return numerator / denominator;
        }

        exports.customMetricCalculation = function (property) {
            return function (dataSource, mappings) {
                if (!_.isArray(mappings)) {
                    return dataSource.getValues(property, mappings);
                }
                if (_.includes(mappings, null)) {
                    return null;
                }

                let metricProperty = exports.customMetricDivision[property];
                if (_.isFunction(metricProperty)) {
                    metricProperty = metricProperty(mappings);
                }

                const numerator = dataSource.getValues(normalizeProperty(metricProperty.numerator, mappings), mappings);
                const denominator = dataSource.getValues(normalizeProperty(metricProperty.denominator, mappings), mappings);
                const sumFn = (metricProperty.ignoreNullValues ? nonstrictSum : strictSum);

                return strictDivide(sumFn(numerator), sumFn(denominator));
            };
        };

        function normalizeProperty(property, mappings) {
            const validMapping = _.find(mappings, function (m) { return !_.isNull(m); });
            const source = _.get(validMapping, 'source');

            // insta insights should use total_reach since total_post_reach conflicts w instagram metrics
            // ( avoid problem of custom dashboard dropdowns switching between channels )
            if (source === enums.sources.INSTAGRAM_INSIGHTS && property === 'total_post_reach') {
                return 'total_reach';
            } else if (source === enums.sources.TWITTER_INSIGHTS) {
                if (property === 'post_impressions') {
                    return 'impressions';
                }
            }
            return property;
        }

        function engagementTotalPerDay(dataSource, mappings) {
            if (!_.isArray(mappings)) {
                return dataSource.getValues('avg_engagement_total_per_day', mappings);
            }

            const engTotal = dataSource.getValues('engagement_total', mappings);

            return strictDivide(strictSum(engTotal), engTotal.length);
        }

        function calculateReachRatePerPost(metric, numerator, denominator, ignoreNullValues) {
            return function (dataSource, mappings) {
                if (!_.isArray(mappings)) {
                    return dataSource.getValues(metric, mappings);
                }
                if (_.includes(mappings, null)) {
                    return null;
                }

                const totalReach = dataSource.getValues(normalizeProperty(numerator, mappings), mappings);

                const totalPosts = dataSource.getValues(denominator, mappings);
                const followers = dataSource.getValues('followers_count', mappings);

                const finalFollowers = [];
                for (let i = 0; i < _.size(followers); i++) {
                    finalFollowers.push(followers[i] * totalPosts[i]);
                }

                const sumFn = (ignoreNullValues ? nonstrictSum : strictSum);
                return strictDivide(sumFn(totalReach), sumFn(finalFollowers));
            };
        }

        function avgFullViewRate(dataSource, mappings) {
            if (!_.isArray(mappings)) {
                return dataSource.getValues('average_full_view_rate', mappings);
            }

            const exits = dataSource.getValues('exits', mappings);
            const taps_forward = dataSource.getValues('taps_forward', mappings);
            const story_impressions = dataSource.getValues('story_impressions', mappings);
            const full_views = [];
            for (let i = 0; i < _.size(story_impressions); i++) {
                full_views[i] = story_impressions[i] - exits[i] - taps_forward[i];
            }

            return strictDivide(strictSum(full_views), strictSum(story_impressions));
        }

        function averageReachRate(dataSource, mappings) {
            if (!_.isArray(mappings)) {
                return dataSource.getValues('average_reach_rate', mappings);
            }

            const totalReach = dataSource.getValues('story_reach', mappings);
            const totalStories = dataSource.getValues('num_stories', mappings);
            const followers = dataSource.getValues('followers_count', mappings);

            const finalFollowers = [];
            for (let i = 0; i < _.size(followers); i++) {
                finalFollowers.push(followers[i] * totalStories[i]);
            }

            return strictDivide(strictSum(totalReach), strictSum(finalFollowers));
        }

        function count(property) {
            function evaluate(value) {
                if (_.isNull(value)) {
                    return null;
                }
                return _.size(value);
            }

            return function (dataSource, mappings) {
                const values = dataSource.getValues(property, mappings);

                if (!_.isArray(values)) {
                    return evaluate(values);
                }

                return _.map(values, evaluate);
            };
        }

        function last(property) {
            return function (dataSource, mappings) {
                const values = dataSource.getValues(property, mappings);

                if (!_.isArray(values)) {
                    return values;
                }
                return _.last(values);
            };
        }

        function lastValue(property) {
            return function (dataSource, mappings) {
                const values = dataSource.getValues(property, mappings);

                if (!_.isArray(values)) {
                    return values;
                }

                return getLastValue(values);
            };
        }

        function getLastValue(values) {
            const lastValue = _.findLast(values, function (val) {
                return !_.isNull(val) && !_.isUndefined(val);
            });

            return (_.isUndefined(lastValue) ? null : lastValue);
        }

        function mean(property) {
            return function (dataSource, mappings) {
                const values = dataSource.getValues(property, mappings);

                if (!_.isArray(values)) {
                    return values;
                }

                return strictDivide(strictSum(values), _.size(values));
            };
        }

        function sum(property) {
            return function (dataSource, mappings) {
                const values = dataSource.getValues(property, mappings);

                if (!_.isArray(values)) {
                    return values;
                }
                return strictSum(values);
            };
        }

        function metaDescriptionQuality(length) {
            let value;

            if (_.isNull(length)) {
                value = null;
            } else if (length > 160) {
                value = 'Long';
            } else if (length < 90) {
                value = 'Short';
            } else {
                value = 'Good';
            }

            return value;
        }

        function metaDescriptionRating(property) {
            const countFn = count(property);

            return function (dataSource, mappings) {
                const count = countFn(dataSource, mappings);
                if (!_.isArray(count)) {
                    return metaDescriptionQuality(count);
                }

                return _.map(count, metaDescriptionQuality);
            };
        }

        function postsPerWeek(metricName) {
            return function (dataSource, mappings) {
                if (!_.isArray(mappings)) {
                    return dataSource.getValues(metricName, mappings);
                }

                const count = dataSource.getValues(metricName, mappings);

                return strictDivide(strictSum(count), count.length);
            };
        }

        exports.rollup = function (dataSource, mappings) {
            let fn;
            const property = dataSource.getProperty();

            if (exports.customMetricDivision[property]) {
                fn = exports.customMetricCalculation(property);
            } else if (exports.fn[property]) {
                fn = exports.fn[property];
            } else if (!_.isArray(mappings)) {
                return dataSource.getValues(property, mappings);
            } else if (dataSource.getMetricType() === enums.metricType.TOTAL) {
                fn = lastValue(property);
            // NOTE this is only legit for _per_day properties
            } else if (dataSource.getMetricValueType() === enums.metricValueType.AVERAGE) {
                fn = mean(property);
            } else {
                fn = sum(property);
            }

            return fn(dataSource, mappings);
        };
    }
})();
